exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell--slot{height:100%;width:100%;display:flex;align-items:center}", ""]);

// exports
